export default "__VITE_ASSET__CjQbg0E7__"